import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";



export const updateReminders = (id: string, payload: object) =>
  patch(`${config.API_URL}/organisation/${id}`, payload);